<template>
    <div class="duanju-info-container">
        <!-- 短剧信息管理区域 -->
        <el-card class="info-card" shadow="never">
            <template #header>
                <div class="card-header">
                    <span>短剧信息管理</span>
                    <div>
                        <el-button type="primary"  @click="handleAdd">
                            新增短剧
                        </el-button>
                        <el-button @click="handleRefresh" icon="el-icon-refresh">
                            刷新
                        </el-button>
                        <!-- <el-button type="warning" icon="el-icon-download" @click="handleExportAll">
                            导出全部
                        </el-button>
                        <el-button type="success" icon="el-icon-download" @click="handleExportSelected" 
                                  :disabled="selectedRows.length === 0">
                            导出选中({{ selectedRows.length }})
                        </el-button> -->
                        <!-- 新增视频下载按钮 -->
                        <el-button type="success" icon="el-icon-upload" @click="handleImportExcel">
                            导入Excel
                        </el-button>
                        <el-button type="info" icon="el-icon-download" @click="handleDownloadTemplate">
                            下载模板
                        </el-button>
                        <el-button type="info" icon="el-icon-video-camera" @click="handleDownloadVideos"
                            :disabled="selectedRows.length === 0" :loading="downloading">
                            下载视频({{ selectedRows.length }})
                        </el-button>
                    </div>
                </div>
            </template>

            <!-- 查询条件区域 -->
            <div class="query-section">
                <el-form :model="queryParams" :inline="true" class="query-form">
                    <el-form-item label="短剧ID" prop="fcPlayletId">
                        <el-input v-model="queryParams.fcPlayletId" placeholder="请输入短剧ID" style="width: 150px" />
                    </el-form-item>
                    <el-form-item label="短剧名称" prop="fcPlayletName">
                        <el-input v-model="queryParams.fcPlayletName" placeholder="请输入短剧名称" style="width: 200px" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleQuery" icon="el-icon-search">
                            查询
                        </el-button>
                        <el-button @click="handleReset" icon="el-icon-refresh">
                            重置
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 表格操作栏 -->
            <div class="table-actions" v-if="selectedRows.length > 0">
                <span>已选择 {{ selectedRows.length }} 项</span>
                <!-- <el-button type="text" @click="clearSelection">清空</el-button>
                <el-button type="text" @click="exportSelectedItems" size="small">导出选中</el-button>
                <el-button type="text" @click="downloadSelectedVideos" size="small" style="color: #909399">
                    下载视频
                </el-button> -->
                <el-button type="text" @click="deleteSelectedItems" size="small" style="color: #F56C6C">
                    批量删除
                </el-button>
            </div>

            <!-- 短剧信息表格 -->
            <el-table :data="tableData" v-loading="loading" border stripe style="width: 100%"
                @selection-change="handleSelectionChange" ref="tableRef">
                <!-- 选择列 -->
                <el-table-column type="selection" width="55" align="center" :selectable="checkSelectable" />

                <!-- 短剧ID列 -->
                <el-table-column prop="fcPlayletId" label="短剧ID" min-width="180" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.fcPlayletId }}</span>
                    </template>
                </el-table-column>

                <!-- 短剧名称列 -->
                <el-table-column prop="fcPlayletName" label="短剧名称" min-width="250" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.fcPlayletName }}</span>
                    </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" width="200" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)" icon="el-icon-edit">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C"
                            icon="el-icon-delete">
                            删除
                        </el-button>
                        <el-button type="text" size="small" @click="handleExportSingle(scope.row)" style="color: #67C23A"
                            icon="el-icon-download">
                            导出
                        </el-button>
                        <!-- 新增单条视频下载按钮 -->
                        <el-button type="text" size="small" @click="handleDownloadSingleVideo(scope.row)"
                            style="color: #909399" icon="el-icon-video-camera">
                            下载视频
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" />
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @closed="handleDialogClosed">
            <el-form :model="formData" :rules="formRules" ref="formRef" label-width="100px">
                <el-form-item label="短剧ID" prop="fcPlayletId">
                    <el-input v-model="formData.fcPlayletId" placeholder="请输入短剧ID" />
                </el-form-item>
                <el-form-item label="短剧名称" prop="fcPlayletName">
                    <el-input v-model="formData.fcPlayletName" placeholder="请输入短剧名称" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitting">
                    确定
                </el-button>
            </span>
        </el-dialog>

        <!-- 删除确认对话框 -->
        <el-dialog title="删除确认" :visible.sync="deleteDialogVisible" width="400px">
            <div style="text-align: center;">
                <i class="el-icon-warning" style="font-size: 40px; color: #F56C6C; margin-bottom: 16px;"></i>
                <p v-if="!isBatchDelete">确定要删除短剧 "{{ currentRow ? currentRow.fcPlayletName : '' }}" 吗？</p>
                <p v-else>确定要删除选中的 {{ selectedRows.length }} 个短剧吗？</p>
                <p style="color: #999; font-size: 12px;">删除后数据将无法恢复</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">取消</el-button>
                <el-button type="danger" @click="confirmDelete" :loading="deleting">
                    确定删除
                </el-button>
            </span>
        </el-dialog>

        <!-- 新增：视频下载确认对话框 -->
        <el-dialog title="视频下载确认" :visible.sync="downloadVideoDialogVisible" width="500px">
            <div style="text-align: center;">
                <i class="el-icon-video-camera" style="font-size: 40px; color: #909399; margin-bottom: 16px;"></i>
                <p>确定要下载选中的 {{ downloadVideoRows.length }} 个短剧视频吗？</p>
                <div v-if="downloadVideoRows.length > 0" style="margin: 16px 0; max-height: 200px; overflow-y: auto;">
                    <div v-for="row in downloadVideoRows" :key="row.id" style="margin: 8px 0;">
                        <el-tag type="info" style="margin: 2px;">
                            {{ row.fcPlayletName }} ({{ row.fcPlayletId }})
                        </el-tag>
                    </div>
                </div>
                <p style="color: #999; font-size: 12px;">
                    视频将打包成ZIP文件下载，请耐心等待...
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadVideoDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmDownloadVideos" :loading="downloading">
                    确定下载
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'DuanjuInfo',
    data() {
        return {
            // API基础URL
            baseURL: 'https://control.zjwec.cn/api/v1/duanju/info',

            // 查询参数
            queryParams: {
                fcPlayletId: '',
                fcPlayletName: ''
            },
            // 表格数据
            tableData: [],
            // 选中的行数据
            selectedRows: [],
            // 表格ref
            tableRef: null,
            // 是否为批量删除
            isBatchDelete: false,
            // 加载状态
            loading: false,
            submitting: false,
            deleting: false,
            // 新增：视频下载相关状态
            downloading: false,
            downloadVideoDialogVisible: false,
            downloadVideoRows: [],
            // 分页参数
            pagination: {
                current: 1,
                size: 10,
                total: 0
            },
            // 对话框控制
            dialogVisible: false,
            deleteDialogVisible: false,
            dialogTitle: '新增短剧',
            currentRow: null,
            // 表单数据
            formData: {
                fcPlayletId: '',
                fcPlayletName: ''
            },
            // 表单验证规则
            formRules: {
                fcPlayletId: [
                    { required: true, message: '请输入短剧ID', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                fcPlayletName: [
                    { required: true, message: '请输入短剧名称', trigger: 'blur' },
                    { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        // 导入Excel
        handleImportExcel() {
            // 创建隐藏的文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = '.xlsx,.xls'
            input.style.display = 'none'

            input.onchange = async (e) => {
                const file = e.target.files[0]
                if (!file) return

                try {
                    this.loading = true
                    this.$message.info('正在解析Excel文件...')

                    // 读取Excel文件
                    const data = await this.readExcelFile(file)

                    if (data.length === 0) {
                        this.$message.warning('Excel文件中没有数据')
                        return
                    }

                    // 调用批量导入接口
                    await this.batchInsertDuanju(data)

                    // 清理
                    document.body.removeChild(input)

                } catch (error) {
                    console.error('导入Excel失败:', error)
                    this.$message.error('导入失败: ' + error.message)
                    document.body.removeChild(input)
                } finally {
                    this.loading = false
                }
            }

            document.body.appendChild(input)
            input.click()
        },

        // 读取Excel文件
        async readExcelFile(file) {
            // 动态导入xlsx库
            const XLSX = await import('xlsx')

            return new Promise((resolve, reject) => {
                const reader = new FileReader()

                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result)
                        const workbook = XLSX.read(data, { type: 'array' })

                        // 获取第一个工作表
                        const firstSheetName = workbook.SheetNames[0]
                        const worksheet = workbook.Sheets[firstSheetName]

                        // 将工作表转换为JSON
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

                        // 验证表头
                        if (jsonData.length < 1) {
                            reject(new Error('Excel文件为空'))
                            return
                        }

                        const headers = jsonData[0]
                        const shortNameIndex = headers.findIndex(h =>
                            h && h.toString().includes('短剧名称')
                        )
                        const idIndex = headers.findIndex(h =>
                            h && h.toString().includes('短剧ID')
                        )

                        if (shortNameIndex === -1 || idIndex === -1) {
                            reject(new Error('请使用正确的模板格式：第一行包含"短剧名称"和"短剧ID"'))
                            return
                        }

                        // 转换数据格式
                        const result = []
                        for (let i = 1; i < jsonData.length; i++) {
                            const row = jsonData[i]
                            if (!row || row.length === 0) continue

                            const fcPlayletName = row[shortNameIndex] ? row[shortNameIndex].toString().trim() : ''
                            const fcPlayletId = row[idIndex] ? row[idIndex].toString().trim() : ''

                            if (fcPlayletId) {
                                result.push({
                                    fcPlayletId: fcPlayletId,
                                    fcPlayletName: fcPlayletName
                                })
                            }
                        }

                        resolve(result)

                    } catch (error) {
                        reject(new Error('解析Excel文件失败: ' + error.message))
                    }
                }

                reader.onerror = () => {
                    reject(new Error('读取文件失败'))
                }

                reader.readAsArrayBuffer(file)
            })
        },

        // 批量导入短剧
        async batchInsertDuanju(duanjuList) {
            try {
                this.$message.info('正在导入数据，请稍候...')

                const response = await this.$axios.post(`${this.baseURL}/batchInsert`, duanjuList)

                if (response.data && response.data.code === "0") {
                    this.$message.success('导入成功: ' + response.data.data)
                    // 刷新表格数据
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '导入失败')
                }

            } catch (error) {
                console.error('批量导入失败:', error)

                if (error.response && error.response.data) {
                    this.$message.error(error.response.data.message || '导入失败')
                } else {
                    this.$message.error('导入失败: ' + error.message)
                }
                throw error
            }
        },

        // 下载导入模板
        handleDownloadTemplate() {
            // 创建模板数据
            const templateData = [
                ['短剧名称', '短剧ID'],
                ['师恩父子情', 'FXJZ1406'],
                ['炼气3000层，开局收女帝为徒', 'FXJZ1108'],
                ['示例短剧1', 'ID001'],
                ['示例短剧2', 'ID002']
            ]

            this.exportTemplateToExcel(templateData, '短剧导入模板')
        },

        // 导出模板
        async exportTemplateToExcel(data, fileName) {
            try {
                const XLSX = await import('xlsx')

                // 创建工作簿
                const wb = XLSX.utils.book_new()
                const ws = XLSX.utils.aoa_to_sheet(data)

                // 设置列宽
                const colWidths = [
                    { wch: 30 }, // 短剧名称
                    { wch: 20 }  // 短剧ID
                ]
                ws['!cols'] = colWidths

                // 设置表头样式
                const range = XLSX.utils.decode_range(ws['!ref'])
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const address = XLSX.utils.encode_cell({ r: 0, c: C })
                    if (ws[address]) {
                        ws[address].s = {
                            font: { bold: true },
                            alignment: { horizontal: 'center', vertical: 'center' },
                            fill: { fgColor: { rgb: "E1F5FE" } }
                        }
                    }
                }

                // 添加工作表
                XLSX.utils.book_append_sheet(wb, ws, '导入模板')

                // 下载文件
                XLSX.writeFile(wb, `${fileName}.xlsx`)

                this.$message.success('模板下载成功，请按照格式填写')

            } catch (error) {
                console.error('下载模板失败:', error)
                this.$message.error('下载模板失败')
            }
        },
        // 获取表格数据
        async fetchData() {
            try {
                this.loading = true
                const params = {
                    current: this.pagination.current,
                    size: this.pagination.size,
                    ...this.queryParams
                }

                // 移除空值参数
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) {
                        delete params[key]
                    }
                })

                const response = await this.$axios.get(`${this.baseURL}/page`, { params })

                if (response.data && response.data.code == "0") {
                    const result = response.data.data
                    this.tableData = result.records || []
                    this.pagination.total = result.total || 0
                    this.pagination.current = result.current || 1
                    this.pagination.size = result.size || 10
                    // 清除选中状态
                    this.clearSelection()
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取数据失败:', error)
                this.$message.error('获取数据失败: ' + error.message)
            } finally {
                this.loading = false
            }
        },
        // 处理查询
        handleQuery() {
            this.pagination.current = 1
            this.fetchData()
        },
        // 处理重置
        handleReset() {
            this.queryParams = {
                fcPlayletId: '',
                fcPlayletName: ''
            }
            this.pagination.current = 1
            this.fetchData()
        },
        // 处理刷新
        handleRefresh() {
            this.fetchData()
        },
        // 处理分页大小变化
        handleSizeChange(size) {
            this.pagination.size = size
            this.fetchData()
        },
        // 处理当前页变化
        handleCurrentChange(current) {
            this.pagination.current = current
            this.fetchData()
        },
        // 处理表格选中状态变化
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },
        // 检查是否可选中
        checkSelectable(row, index) {
            return true
        },
        // 清空选中
        clearSelection() {
            this.selectedRows = []
            if (this.$refs.tableRef) {
                this.$refs.tableRef.clearSelection()
            }
        },
        // 导出选中项
        exportSelectedItems() {
            if (this.selectedRows.length == 0) {
                this.$message.warning('请先选择要导出的短剧')
                return
            }
            this.exportToExcel(this.selectedRows, '选中短剧信息')
        },
        // 导出单个短剧详情
        async handleExportSingle(row) {
            try {
                // 显示加载状态
                this.loading = true

                // 调用详情接口
                const response = await this.$axios.get(`${this.baseURL}/excel`, {
                    params: { fcPlayletId: row.fcPlayletId }
                })

                if (response.data && response.data.code == 2000) {
                    const detailData = response.data.data
                    // 格式化数据并导出Excel
                    await this.exportEpisodeDetailsToExcel(detailData, row.fcPlayletId, row.fcPlayletName)
                } else {
                    this.$message.error(response.data.message || '获取短剧详情失败')
                }
            } catch (error) {
                console.error('导出短剧详情失败:', error)
                this.$message.error('导出短剧详情失败: ' + error.message)
            } finally {
                this.loading = false
            }
        },

        // 导出集数详情到Excel（以episodeDetails中的对象为一行）
        async exportEpisodeDetailsToExcel(detailData, fcPlayletId, fcPlayletName) {
            try {
                // 动态导入xlsx库
                const XLSX = await import('xlsx')

                // 准备表头
                const headers = [
                    '短剧名称',
                    '短剧ID',
                    '简介',
                    '封面链接',
                    '状态',
                    '分类',
                    '级别',
                    '集数序号',
                    '集数ID',
                    '集数标题',
                    '集数链接',
                    '集数状态',
                    '导出时间'
                ]

                // 准备数据行
                const dataRows = []

                // 获取基本信息
                const basicInfo = {
                    name: detailData.name || '',
                    id: fcPlayletId,
                    introduction: detailData.introduction || '',
                    coverWap: detailData.coverWap || '',
                    status: this.getStatusText(detailData.status),
                    category: detailData.fcCategoryList.join('、') || '',
                    level: detailData.level || '',
                    exportTime: new Date().toLocaleString()
                }

                // 如果有集数信息，为每个集数创建一行
                if (detailData.episodeDetails && detailData.episodeDetails.length > 0) {
                    detailData.episodeDetails.forEach(episode => {
                        const row = [
                            basicInfo.name,                    // 短剧名称
                            basicInfo.id,                      // 短剧ID
                            basicInfo.introduction,            // 简介
                            basicInfo.coverWap,                // 封面链接
                            basicInfo.status,                  // 状态
                            basicInfo.category,                // 分类
                            basicInfo.level,                   // 级别
                            episode.order || '',               // 集数序号
                            episode.episodeId || '',           // 集数ID
                            episode.title || '',               // 集数标题
                            episode.url || '',                 // 集数链接
                            this.getStatusText(episode.status),// 集数状态
                            basicInfo.exportTime               // 导出时间
                        ]
                        dataRows.push(row)
                    })
                } else {
                    // 如果没有集数信息，只创建一行基本信息
                    const row = [
                        basicInfo.name,        // 短剧名称
                        basicInfo.id,          // 短剧ID
                        basicInfo.introduction,// 简介
                        basicInfo.coverWap,    // 封面链接
                        basicInfo.status,      // 状态
                        basicInfo.category,    // 分类
                        basicInfo.level,       // 级别
                        '',                    // 集数序号
                        '',                    // 集数ID
                        '',                    // 集数标题
                        '',                    // 集数链接
                        '',                    // 集数状态
                        basicInfo.exportTime   // 导出时间
                    ]
                    dataRows.push(row)
                }

                // 合并表头和数据
                const sheetData = [headers, ...dataRows]

                // 创建工作表
                const ws = XLSX.utils.aoa_to_sheet(sheetData)

                // 设置列宽
                const colWidths = [
                    { wch: 20 },  // 短剧名称
                    { wch: 20 },  // 短剧ID
                    { wch: 50 },  // 简介
                    { wch: 60 },  // 封面链接
                    { wch: 10 },  // 状态
                    { wch: 15 },  // 分类
                    { wch: 10 },  // 级别
                    { wch: 10 },  // 集数序号
                    { wch: 25 },  // 集数ID
                    { wch: 60 },  // 集数标题
                    { wch: 80 },  // 集数链接
                    { wch: 10 },  // 集数状态
                    { wch: 20 }   // 导出时间
                ];
                ws['!cols'] = colWidths;

                // 设置表头样式
                const headerRange = XLSX.utils.decode_range(ws['!ref']);
                for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
                    const address = XLSX.utils.encode_cell({ r: 0, c: C });
                    if (ws[address]) {
                        ws[address].s = {
                            font: { bold: true, sz: 12 },
                            alignment: { horizontal: 'center', vertical: 'center' },
                            fill: { fgColor: { rgb: "E1F5FE" } }, // 浅蓝色背景
                            border: {
                                top: { style: 'thin', color: { rgb: "000000" } },
                                bottom: { style: 'thin', color: { rgb: "000000" } },
                                left: { style: 'thin', color: { rgb: "000000" } },
                                right: { style: 'thin', color: { rgb: "000000" } }
                            }
                        };
                    }
                }

                // 设置数据行样式
                for (let R = 1; R <= headerRange.e.r; ++R) {
                    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
                        const address = XLSX.utils.encode_cell({ r: R, c: C });
                        if (ws[address]) {
                            ws[address].s = {
                                alignment: {
                                    horizontal: 'left',
                                    vertical: 'center',
                                    wrapText: true // 允许换行
                                },
                                border: {
                                    top: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    bottom: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    left: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    right: { style: 'thin', color: { rgb: "E0E0E0" } }
                                }
                            };

                            // 为特定列设置不同的对齐方式
                            if (C === 0 || C === 1 || C === 4 || C === 5 || C === 6 || C === 7 || C === 11) {
                                ws[address].s.alignment.horizontal = 'center';
                            }
                        }
                    }
                }

                // 创建工作簿
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, '短剧详情');

                // 生成Excel文件名
                const timestamp = new Date().toISOString().split('T')[0].replace(/-/g, '');
                const fileName = `${fcPlayletName || '短剧'}_${fcPlayletId}_详情_${timestamp}.xlsx`;

                // 下载Excel文件
                XLSX.writeFile(wb, fileName);

                this.$message.success(`成功导出短剧详情: ${detailData.name || fcPlayletName}，共 ${dataRows.length} 行数据`);

            } catch (error) {
                console.error('导出Excel失败:', error);
                this.$message.error('导出Excel失败: ' + error.message);
            }
        },

        // 批量导出选中短剧的详情
        async handleBatchExportDetails() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要导出详情的短剧')
                return
            }

            try {
                this.batchExporting = true

                // 准备所有数据
                const allEpisodeData = []
                const headers = [
                    '短剧名称',
                    '短剧ID',
                    '简介',
                    '封面链接',
                    '状态',
                    '分类',
                    '级别',
                    '集数序号',
                    '集数ID',
                    '集数标题',
                    '集数链接',
                    '集数状态',
                    '导出时间'
                ]

                // 添加表头
                allEpisodeData.push(headers)

                this.$message.info(`开始批量导出 ${this.selectedRows.length} 个短剧的详情，请稍候...`)

                // 为每个选中的短剧获取详情
                for (let i = 0; i < this.selectedRows.length; i++) {
                    const row = this.selectedRows[i]
                    try {
                        // 调用详情接口
                        const response = await this.$axios.get(`${this.baseURL}/excel`, {
                            params: { fcPlayletId: row.fcPlayletId }
                        })

                        if (response.data && response.data.code === 2000) {
                            const detailData = response.data.data

                            // 获取基本信息
                            const basicInfo = {
                                name: detailData.name || row.fcPlayletName || '',
                                id: row.fcPlayletId,
                                introduction: detailData.introduction || '',
                                coverWap: detailData.coverWap || '',
                                status: this.getStatusText(detailData.status),
                                category: detailData.fcCategoryList.join('、') || '',
                                level: detailData.level || '',
                                exportTime: new Date().toLocaleString()
                            }

                            // 如果有集数信息，为每个集数创建一行
                            if (detailData.episodeDetails && detailData.episodeDetails.length > 0) {
                                detailData.episodeDetails.forEach(episode => {
                                    const dataRow = [
                                        basicInfo.name,                    // 短剧名称
                                        basicInfo.id,                      // 短剧ID
                                        basicInfo.introduction,            // 简介
                                        basicInfo.coverWap,                // 封面链接
                                        basicInfo.status,                  // 状态
                                        basicInfo.category,                // 分类
                                        basicInfo.level,                   // 级别
                                        episode.order || '',               // 集数序号
                                        episode.episodeId || '',           // 集数ID
                                        episode.title || '',               // 集数标题
                                        episode.url || '',                 // 集数链接
                                        this.getStatusText(episode.status),// 集数状态
                                        basicInfo.exportTime               // 导出时间
                                    ]
                                    allEpisodeData.push(dataRow)
                                })
                            } else {
                                // 如果没有集数信息，只创建一行基本信息
                                const dataRow = [
                                    basicInfo.name,        // 短剧名称
                                    basicInfo.id,          // 短剧ID
                                    basicInfo.introduction,// 简介
                                    basicInfo.coverWap,    // 封面链接
                                    basicInfo.status,      // 状态
                                    basicInfo.category,    // 分类
                                    basicInfo.level,       // 级别
                                    '',                    // 集数序号
                                    '',                    // 集数ID
                                    '',                    // 集数标题
                                    '',                    // 集数链接
                                    '',                    // 集数状态
                                    basicInfo.exportTime   // 导出时间
                                ]
                                allEpisodeData.push(dataRow)
                            }

                            this.$message.success(`已获取短剧: ${basicInfo.name}`)
                        } else {
                            console.warn(`获取短剧 ${row.fcPlayletId} 详情失败:`, response.data.message)

                            // 即使失败也添加一行基本信息
                            const dataRow = [
                                row.fcPlayletName || '',
                                row.fcPlayletId,
                                '获取详情失败',
                                '',
                                '未知',
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                new Date().toLocaleString()
                            ]
                            allEpisodeData.push(dataRow)
                        }
                    } catch (error) {
                        console.error(`获取短剧 ${row.fcPlayletId} 详情失败:`, error)

                        // 出错时也添加一行基本信息
                        const dataRow = [
                            row.fcPlayletName || '',
                            row.fcPlayletId,
                            '获取详情出错: ' + error.message,
                            '',
                            '错误',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            new Date().toLocaleString()
                        ]
                        allEpisodeData.push(dataRow)
                    }

                    // 添加一点延迟，避免请求过于频繁
                    if (i < this.selectedRows.length - 1) {
                        await new Promise(resolve => setTimeout(resolve, 300))
                    }
                }

                // 如果有数据，导出Excel
                if (allEpisodeData.length > 1) { // 大于1是因为有表头
                    await this.exportCombinedDataToExcel(allEpisodeData)
                    this.$message.success(`批量导出完成，共导出 ${allEpisodeData.length - 1} 行数据`)
                } else {
                    this.$message.warning('没有成功获取到任何数据')
                }

            } catch (error) {
                console.error('批量导出详情失败:', error)
                this.$message.error('批量导出详情失败: ' + error.message)
            } finally {
                this.batchExporting = false
            }
        },

        // 导出合并后的数据到Excel
        async exportCombinedDataToExcel(sheetData) {
            try {
                // 动态导入xlsx库
                const XLSX = await import('xlsx')

                // 创建工作表
                const ws = XLSX.utils.aoa_to_sheet(sheetData)

                // 设置列宽
                const colWidths = [
                    { wch: 20 },  // 短剧名称
                    { wch: 20 },  // 短剧ID
                    { wch: 50 },  // 简介
                    { wch: 60 },  // 封面链接
                    { wch: 10 },  // 状态
                    { wch: 15 },  // 分类
                    { wch: 10 },  // 级别
                    { wch: 10 },  // 集数序号
                    { wch: 25 },  // 集数ID
                    { wch: 60 },  // 集数标题
                    { wch: 80 },  // 集数链接
                    { wch: 10 },  // 集数状态
                    { wch: 20 }   // 导出时间
                ];
                ws['!cols'] = colWidths;

                // 设置表头样式
                const headerRange = XLSX.utils.decode_range(ws['!ref']);
                for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
                    const address = XLSX.utils.encode_cell({ r: 0, c: C });
                    if (ws[address]) {
                        ws[address].s = {
                            font: { bold: true, sz: 12 },
                            alignment: { horizontal: 'center', vertical: 'center' },
                            fill: { fgColor: { rgb: "E1F5FE" } }, // 浅蓝色背景
                            border: {
                                top: { style: 'thin', color: { rgb: "000000" } },
                                bottom: { style: 'thin', color: { rgb: "000000" } },
                                left: { style: 'thin', color: { rgb: "000000" } },
                                right: { style: 'thin', color: { rgb: "000000" } }
                            }
                        };
                    }
                }

                // 设置数据行样式
                for (let R = 1; R <= headerRange.e.r; ++R) {
                    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
                        const address = XLSX.utils.encode_cell({ r: R, c: C });
                        if (ws[address]) {
                            ws[address].s = {
                                alignment: {
                                    horizontal: 'left',
                                    vertical: 'center',
                                    wrapText: true
                                },
                                border: {
                                    top: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    bottom: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    left: { style: 'thin', color: { rgb: "E0E0E0" } },
                                    right: { style: 'thin', color: { rgb: "E0E0E0" } }
                                }
                            };

                            // 为特定列设置居中对齐
                            if (C === 0 || C === 1 || C === 4 || C === 5 || C === 6 || C === 7 || C === 11) {
                                ws[address].s.alignment.horizontal = 'center';
                            }
                        }
                    }
                }

                // 创建工作簿
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, '短剧批量详情');

                // 生成Excel文件名
                const timestamp = new Date().toISOString().split('T')[0].replace(/-/g, '');
                const fileName = `短剧批量详情_${timestamp}.xlsx`;

                // 下载Excel文件
                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error('导出合并Excel失败:', error);
                this.$message.error('导出合并Excel失败: ' + error.message);
            }
        },

        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                1: '正常',
                0: '禁用',
                2: '审核中',
                3: '已下架'
            }
            return statusMap[status] || '未知'
        },
        // 导出全部
        handleExportAll() {
            this.exportToExcel(this.tableData, '全部短剧信息')
        },
        // 导出选中按钮
        handleExportSelected() {
            this.exportSelectedItems()
        },
        // 导出到Excel
        async exportToExcel(data, fileNamePrefix) {
            if (!data || data.length === 0) {
                this.$message.warning('没有数据可导出')
                return
            }

            try {
                // 动态导入xlsx库
                const XLSX = await import('xlsx')

                // 准备Excel数据
                const excelData = data.map(row => ({
                    '短剧ID': row.fcPlayletId || '',
                    '短剧名称': row.fcPlayletName || ''
                }));

                // 创建工作簿
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);

                // 设置列宽
                const colWidths = [
                    { wch: 30 },
                    { wch: 50 }
                ];
                ws['!cols'] = colWidths;

                // 将工作表添加到工作簿
                XLSX.utils.book_append_sheet(wb, ws, '短剧信息');

                // 生成Excel文件并下载
                const timestamp = new Date().toISOString().split('T')[0].replace(/-/g, '');
                const fileName = `${fileNamePrefix}_${timestamp}.xlsx`;
                XLSX.writeFile(wb, fileName);

                this.$message.success(`成功导出 ${data.length} 条数据`);

            } catch (error) {
                console.error('导出Excel失败:', error);
                this.$message.error('导出Excel失败: ' + error.message);
            }
        },
        // 批量删除选中项
        deleteSelectedItems() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要删除的短剧')
                return
            }
            this.isBatchDelete = true
            this.deleteDialogVisible = true
        },
        // 新增：视频下载主按钮
        handleDownloadVideos() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要下载的短剧')
                return
            }
            this.downloadVideoRows = [...this.selectedRows]
            this.downloadVideoDialogVisible = true
        },
        // 新增：表格操作栏视频下载按钮
        downloadSelectedVideos() {
            this.handleDownloadVideos()
        },
        // 新增：下载单个短剧视频
        handleDownloadSingleVideo(row) {
            this.downloadVideoRows = [row]
            this.downloadVideoDialogVisible = true
        },
        // 新增：确认下载视频
        async confirmDownloadVideos() {
            if (this.downloadVideoRows.length === 0) {
                this.$message.warning('请选择要下载的短剧')
                return
            }

            try {
                this.downloading = true
                this.$message.info('开始下载，请稍候...')

                const fcPlayletIds = this.downloadVideoRows.map(row => row.fcPlayletId)

                const response = await this.$axios({
                    url: `${this.baseURL}/download`,
                    method: 'post',
                    data: fcPlayletIds, // 直接传数组，axios会自动转JSON
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

                // 获取文件名
                let fileName = 'duanju-videos.zip'
                const contentDisposition = response.headers['content-disposition']
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/)
                    if (match && match[1]) {
                        fileName = decodeURIComponent(match[1])
                    }
                }

                // 创建下载链接
                const blob = response.data
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = fileName
                document.body.appendChild(link)
                link.click()

                // 清理
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                    document.body.removeChild(link)
                }, 1000)

                this.$message.success(`成功下载 ${fcPlayletIds.length} 个短剧视频`)
                this.downloadVideoDialogVisible = false

            } catch (error) {
                console.error('下载视频失败:', error)

                // 简单打印错误信息
                if (error.response && error.response.data) {
                    // 如果是Blob类型的错误响应
                    if (error.response.data instanceof Blob) {
                        try {
                            const text = await error.response.data.text()
                            const errorData = JSON.parse(text)
                            // 直接打印message
                            this.$message.error(errorData.message || '下载失败')
                        } catch (error) {
                            this.$message.error(error)
                        }
                    }
                    // 如果是JSON错误响应
                    else if (error.response.data.message) {
                        this.$message.error(error.response.data.message)
                    }
                } else {
                    this.$message.error(error.message || '下载失败')
                }
            } finally {
                this.downloading = false
            }
        },
        // 新增短剧
        handleAdd() {
            this.dialogTitle = '新增短剧'
            this.formData = {
                fcPlayletId: '',
                fcPlayletName: ''
            }
            this.dialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate()
                }
            })
        },
        // 编辑短剧
        handleEdit(row) {
            this.dialogTitle = '编辑短剧'
            this.formData = {
                fcPlayletId: row.fcPlayletId,
                fcPlayletName: row.fcPlayletName
            }
            this.currentRow = row
            this.dialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate()
                }
            })
        },
        // 删除短剧
        handleDelete(row) {
            this.currentRow = row
            this.isBatchDelete = false
            this.deleteDialogVisible = true
        },
        // 确认删除
        async confirmDelete() {
            try {
                this.deleting = true

                if (this.isBatchDelete) {
                    // 批量删除 - 使用新的接口
                    const ids = this.selectedRows.map(row => row.id.toString()) // 确保是字符串数组

                    const response = await this.$axios.post(`${this.baseURL}/batchDelete`, ids, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })

                    if (response.data && response.data.code == "0") {
                        this.$message.success(`成功删除 ${ids.length} 个短剧`)
                        this.fetchData()
                        // 清空选中状态
                        this.clearSelection()
                    } else {
                        this.$message.error(response.data.message || '批量删除失败')
                    }
                } else {
                    // 单个删除 - 保持原来的逻辑
                    const response = await this.$axios.get(`${this.baseURL}/delete`, {
                        params: { id: this.currentRow.id }
                    })

                    if (response.data && response.data.code === "0") {
                        this.$message.success('删除成功')
                        this.fetchData()
                    } else {
                        this.$message.error(response.data.message || '删除失败')
                    }
                }

                this.deleteDialogVisible = false
            } catch (error) {
                console.error('删除失败:', error)

                // 提供更详细的错误信息
                if (error.response) {
                    // 服务器返回错误状态码
                    if (error.response.data && error.response.data.message) {
                        this.$message.error(`删除失败: ${error.response.data.message}`)
                    } else {
                        this.$message.error(`删除失败: 服务器错误 ${error.response.status}`)
                    }
                } else if (error.request) {
                    // 请求已发送但没有响应
                    this.$message.error('删除失败: 服务器无响应，请检查网络连接')
                } else {
                    // 请求配置错误
                    this.$message.error('删除失败: ' + error.message)
                }
            } finally {
                this.deleting = false
                this.isBatchDelete = false
            }
        },
        // 提交表单（新增/编辑）
        async handleSubmit() {
            try {
                // 表单验证
                await this.$refs.formRef.validate()

                this.submitting = true
                const response = await this.$axios.post(`${this.baseURL}/insert`, this.formData)

                if (response.data && response.data.code === "0") {
                    this.$message.success(this.dialogTitle + '成功')
                    this.dialogVisible = false
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '操作失败')
                }
            } catch (error) {
                if (error.name !== 'ValidationError') {
                    console.error('操作失败:', error)
                    this.$message.error('操作失败: ' + error.message)
                }
            } finally {
                this.submitting = false
            }
        },
        // 对话框关闭
        handleDialogClosed() {
            if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate()
            }
        }
    }
}
</script>

<style scoped>
.duanju-info-container {
    padding: 20px;
}

.info-card {
    margin-bottom: 20px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.query-section {
    margin-bottom: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 4px;
}

.query-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
}

.table-actions {
    margin-bottom: 16px;
    padding: 12px 16px;
    background-color: #f0f8ff;
    border: 1px solid #e1e4e8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.table-actions span {
    color: #409eff;
    font-weight: 500;
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .query-form {
        flex-direction: column;
        align-items: stretch;
    }

    .query-form .el-form-item {
        width: 100%;
        margin-right: 0;
    }

    .query-form .el-form-item .el-input {
        width: 100%;
    }

    .card-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .card-header>div {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/login/quickAppquery.vue